module.exports = __webpack_public_path__ + "static/media/JAROPOJOP-JEROME-MICO.2796ce1f.docx";